import { render, staticRenderFns } from "./CustomerDetailsPrivate.vue?vue&type=template&id=72b9f350&scoped=true&"
import script from "./CustomerDetailsPrivate.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailsPrivate.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailsPrivate.vue?vue&type=style&index=0&id=72b9f350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9f350",
  null
  
)

export default component.exports